import React from "react";
import { Row, Col } from "antd";
const TheFooter = () => {
  return (
    <Row className="footer" type="flex" justify="center" align="middle">
      <Col>Copyright © OrgBioChem 2018</Col>
    </Row>
    // <footer className="footer">
    //   <div className="container">
    //     <div className="row">
    //       <div className="col-lg-12 col-md-12">
    //         <p>Copyright © OrgBioChem 2018</p>
    //         <small className="footer-gatsby">
    //           Developed with love by GMinovska
    //         </small>
    //       </div>
    //     </div>
    //   </div>
    // </footer>
  );
};

export default TheFooter;
